class ObservableUtil{

	constructor(){
        // if a component wants to listen for some asset change
        // it can give a callback and callback id to the callback system.
        // it will use the action type and assetID as a key to know when
        // to call the callbacks.
        this.changeCallbackMap = {}

        this.actionCallbackMap = {}
    }

    subscribeToChange(actionId, assetId, functionID, func){
        if(!this.changeCallbackMap[actionId + assetId]) 
            this.changeCallbackMap[actionId + assetId] = {};

        this.changeCallbackMap[actionId + assetId][functionID] = func;
    }

    unsubscribeToChange(actionId, assetId, functionID){
        if(this.changeCallbackMap[actionId  + assetId]){
            delete this.changeCallbackMap[actionId  + assetId][functionID];
            if(Object.keys(this.changeCallbackMap[actionId  + assetId]) == 0){
                delete this.changeCallbackMap[actionId  + assetId];
            }
        }else {
            console.warn("unsubscribing from something that doesnt exist", assetId)
        }
    }
    
    // When the action is complete, the function will get 
    // the server response  as the parameter.
    callChangeSubscribers(actionId, assetIds, res, isError){
        if(!Array.isArray(assetIds)) assetIds = [assetIds];
        assetIds.map( assetId =>{
            if(this.changeCallbackMap[actionId + assetId]){
                for(var funcKey in this.changeCallbackMap[actionId + assetId]){
                    if(this.changeCallbackMap[actionId + assetId].hasOwnProperty(funcKey)){
                        this.changeCallbackMap[actionId + assetId][funcKey](res, isError);
                    }
                }
            }
        });

        for(var funcKey in this.changeCallbackMap[actionId + "all"]){
            if(this.changeCallbackMap[actionId + "all"].hasOwnProperty(funcKey)){
                this.changeCallbackMap[actionId + "all"][funcKey](res);
            }
        }
    }
    
    subscribeToAction(actionId, assetId, functionID, func){
        if(!this.actionCallbackMap[actionId + assetId]) 
            this.actionCallbackMap[actionId + assetId] = {};

        this.actionCallbackMap[actionId + assetId][functionID] = func;
    }
    
    unsubscribeToAction(actionId, assetId, functionID){
        if(this.actionCallbackMap[actionId  + assetId]){
            delete this.actionCallbackMap[actionId  + assetId][functionID];
            if(Object.keys(this.actionCallbackMap[actionId  + assetId]) == 0){
                delete this.actionCallbackMap[actionId  + assetId];
            }
        }else {
            console.warn("unsubscribing from something that doesnt exist", assetId)
        }
    }

    // When the action is complete, the function will get 
    // the server response  as the parameter.
    callActionSubscribers(actionId, assetIds, res, error){
        if(!Array.isArray(assetIds)) assetIds = [assetIds];
        assetIds.map( assetId =>{
            if(this.actionCallbackMap[actionId + assetId]){
                for(var funcKey in this.actionCallbackMap[actionId + assetId]){
                    if(this.actionCallbackMap[actionId + assetId].hasOwnProperty(funcKey)){
                        this.actionCallbackMap[actionId + assetId][funcKey](res, error);
                    }
                }
            }
        });

        for(var funcKey in this.actionCallbackMap[actionId + "all"]){
            if(this.actionCallbackMap[actionId + "all"].hasOwnProperty(funcKey)){
                this.actionCallbackMap[actionId + "all"][funcKey](res, error);
            }
        }
    }

    transferOwnershipHub(data, setConfirmation, setLoading, setError){
        setConfirmation(true, `Transfer Ownership?`,
                              `There can only be one owner per hub.<br><br>
                                Are you sure you want to transfer ownership of <span class="bold">${data.hub.name}</span> to 
                                <span class="bold">${data.newOwner.name}</span>?
                                Your role will be changed to Contributor, and you will no longer be able to add or remove members from the hub`,
            () => {
                setLoading(true, `Sending invitation ${data.newOwner.name}`);
                return ContentServerClient.sendInvitationTransferHub({hubId: data.hub.id, idNewOwner: data.newOwner.id})
                    .then(() => ContentServerClient.getMembersHub(data.hub.id))
                    .then(({members}) => {
                        setLoading(false)
                        this.callChangeSubscribers("transferring", data.hub.id, {members});
                    })
                    .catch(err => {
                        setLoading(false);
                        this.callChangeSubscribers("transferring", data.hub.id, err, true);
                        setError(true, `Error transferring ownership`, `cause: ${err.message}`);
                    });
            }
        );
    }

    cancelTransferOwnershipHub(data, setConfirmation, setLoading, setError){
        setConfirmation(true, `Cancel Transfer Ownership`,
                              `Are you sure you want to cancel tranfer ownership of <span class="bold">${data.hub.name}</span> to 
                                <span class="bold">${data.newOwner.name}</span>?`,
            () => {
                setLoading(true, `Canceling invitation ${data.newOwner.name}`);
                return ContentServerClient.getListTransfersFrom()
                        .then(({transfers}) => transfers.reduce((accum, {id: transferId, to: idNewOwner, hub_id}) => {
                                                    if(idNewOwner === data.newOwner.id && data.hub.id === hub_id){ accum = transferId}
                                                    return accum;
                                                },0)
                        )
                        .then(transferId => ContentServerClient.cancelTransferHub({transferId}))
                        .then(() => ContentServerClient.getMembersHub(data.hub.id))
                        .then(({members}) => {
                            setLoading(false)
                            this.callChangeSubscribers("cancelTransferring", data.hub.id, {members});
                        })
                        .catch(err => {
                            setLoading(false);
                            this.callChangeSubscribers("transferring", data.hub.id, err, true);
                            setError(true, `Error canceling the transfer ownership`, `cause: ${err.message}`);
                        });
            }
        );
    }

}

module.exports = new ObservableUtil();
